import { useState, useEffect } from 'react';

const usePath = () => {
  const [path, setPath] = useState(window.location.pathname);

  const listenToPopstate = () => {
    const winPath = window.location.pathname;
    setPath(winPath);
  };

  useEffect(() => {
    document.addEventListener('pushToHistory', listenToPopstate);
    window.addEventListener('popstate', listenToPopstate);
    return () => {
      document.removeEventListener('pushToHistory', listenToPopstate);
      window.removeEventListener('popstate', listenToPopstate);
    };
  });

  return path;
};

export default usePath;
